import { ArrowRight, Mail } from "lucide-react";
import { FormEvent, useState } from "react";

export function NewsletterCapture() {
  const [email, setEmail] = useState("");
  const [notice, setNotice] = useState("");

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setNotice("Newsletter enrollment will be available after Kratown’s Constant Contact connection is completed. Your email address has not been submitted.");
    setEmail("");
  };

  return (
    <section aria-labelledby="newsletter-heading" className="rounded-[1.75rem] border border-[#36d8ff]/18 bg-[linear-gradient(135deg,rgba(54,216,255,0.11),rgba(194,255,69,0.08))] p-6 shadow-[inset_0_1px_0_rgba(255,255,255,0.06)] md:p-8">
      <div className="grid gap-6 lg:grid-cols-[0.9fr_1.1fr] lg:items-end">
        <div>
          <div className="flex items-center gap-3 text-[#8beeff]"><Mail className="h-5 w-5" aria-hidden="true" /><p className="text-xs font-semibold uppercase tracking-[0.2em]">Kratown updates</p></div>
          <h2 id="newsletter-heading" className="mt-4 font-serif text-4xl text-white md:text-5xl">Good things, delivered thoughtfully.</h2>
          <p className="mt-4 max-w-xl text-sm leading-7 text-white/72">Sign up for product updates and Kratown news. You can unsubscribe at any time.</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-3" noValidate>
          <label htmlFor="newsletter-email" className="sr-only">Email address</label>
          <div className="flex flex-col gap-3 sm:flex-row">
            <input id="newsletter-email" name="email" type="email" value={email} onChange={(event) => setEmail(event.target.value)} required autoComplete="email" placeholder="Email address" className="min-h-12 flex-1 rounded-xl border border-white/14 bg-[#061310]/70 px-4 text-base text-white placeholder:text-white/42 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#c2ff45]" />
            <button type="submit" className="inline-flex min-h-12 items-center justify-center rounded-xl border border-[#c2ff45]/35 bg-[#c2ff45] px-5 text-sm font-semibold text-[#07110f] transition hover:bg-[#d1ff71] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white">Get updates<ArrowRight className="ml-2 h-4 w-4" aria-hidden="true" /></button>
          </div>
          <p className="text-xs leading-6 text-white/55">By continuing, you agree to receive Kratown marketing communications. <a href="/privacy" className="text-[#d9ff8a] underline-offset-4 hover:underline">Privacy policy</a></p>
          {notice ? <p role="status" className="rounded-xl border border-[#ffd27c]/25 bg-[#ffcc7b]/10 px-4 py-3 text-sm leading-6 text-[#ffe3ad]">{notice}</p> : null}
        </form>
      </div>
    </section>
  );
}
